import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * Returns a stable-identity function that always invokes the latest `fn`. Safe to attach as a
 * long-lived event listener (add/removeEventListener match) while `fn` re-closes over fresh state.
 */
export const useEventCallback = <Args extends unknown[], R>(
  fn: (...args: Args) => R,
): ((...args: Args) => R) => {
  const ref = useRef(fn);
  // Updated on commit (not during render) so an abandoned concurrent render can't leak its closure.
  useLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback((...args: Args) => ref.current(...args), []);
};
